/**
 *
 * @typedef {{error_message: string|undefined, results: [{formatted_address: string, types: string[], geometry: {viewport: {southwest: {lng: number, lat: number}, northeast: {lng: number, lat: number}}, bounds: {southwest: {lng: number, lat: number}, northeast: {lng: number, lat: number}}, location: {lng: number, lat: number}, location_type: string}, address_components: [{types: string[], short_name: string, long_name: string},{types: string[], short_name: string, long_name: string},{types: string[], short_name: string, long_name: string},{types: string[], short_name: string, long_name: string},{types: string[], short_name: string, long_name: string}], place_id: string, postcode_localities: string[]}], status: string}} GoogleGeocodeResponse
 */

/**
 * @callback googleGeolocateAddressSuccessCallback
 * @param {{longitude: number, latitude: number}} coords
 */

/**
 * @callback googleGeolocateAddressFailureCallback
 * @param {{}} googleResponse
 */

/**
 * get the latitude/longitude of an address via Google's geocoder
 *
 * @see https://developers.google.com/maps/documentation/geocoding/requests-geocoding?hl=en_US
 *
 * @param {string} address
 * @param {string} apiKey
 * @param {googleGeolocateAddressSuccessCallback} successCallback
 * @param {googleGeolocateAddressFailureCallback} failureCallback
 */
const googleGeolocateAddress = ( address, apiKey, successCallback, failureCallback ) =>
{
	const url = new URL( 'https://maps.googleapis.com/maps/api/geocode/json' );

	url.searchParams.append( 'key', apiKey );
	url.searchParams.append( 'address', address );

	fetch( url.toString() ).then( response =>
	{
		/**
		 * @typedef {GoogleGeocodeResponse} googleResponse
		 */
		response.json().then( googleResponse =>
		{
			if (googleResponse.status === 'OK' && googleResponse.results.length) {

				successCallback( {
					latitude:  googleResponse.results[0].geometry.location.lat,
					longitude: googleResponse.results[0].geometry.location.lng,
				} );

			} else {

				failureCallback( googleResponse );
			}
		} );
	} );
};


/**
 * Get the distance between to geographical coordinates, in miles or kilometers, as the crow flies
 *
 * @param {{latitude: number, longitude: number}} coords1
 * @param {{latitude: number, longitude: number}} coords2
 * @param {boolean} inMiles - miles or kilometers
 * @returns {number}
 */
const getDistance = ( coords1, coords2, inMiles = true ) =>
{
	const earthRadius = inMiles ? 3959 : 6371; // mi : km
	const dLat        = deg2rad( coords2.latitude - coords1.latitude );
	const dLon        = deg2rad( coords2.longitude - coords1.longitude );
	const radLat1     = deg2rad( coords1.latitude );
	const radLat2     = deg2rad( coords2.latitude );
	const a           = Math.sin( dLat / 2 ) * Math.sin( dLat / 2 ) +
		Math.sin( dLon / 2 ) * Math.sin( dLon / 2 ) * Math.cos( radLat1 ) * Math.cos( radLat2 );
	const c           = 2 * Math.atan2( Math.sqrt( a ), Math.sqrt( 1 - a ) );

	return earthRadius * c;
}


/**
 * convert degrees to radians
 *
 * @param {number} degrees
 * @returns {number}
 */
const deg2rad = degrees =>
{
	return degrees * Math.PI / 180;
}


/**
 *
 */
export {getDistance, googleGeolocateAddress};